import React, { memo, VFC } from 'react';

import { CardListItem } from '~/@components/CardListItem';
import { Grid } from '~/@components/Grid';
import { Text } from '~/@components/Text';
import { fuelList, getFuelSetting, VehicleType } from '~/@store/vehicleTypes';
import i18n from '~/i18n';

type VehicleTypeCardProps = {
    vehicleType: VehicleType;
    select: () => void;
    isActive?: boolean;
};

export const VehicleTypeCard: VFC<VehicleTypeCardProps> = memo(({ vehicleType, isActive, select }) => {
    return (
        <CardListItem isActive={isActive} onClick={select}>
            <Grid container spacing={1}>
                <Grid item xs={3}>
                    <Text variant="BodyRegular" ellipsis>
                        {vehicleType.name}
                    </Text>
                    <Text variant="SmallText" color="textSecondary">
                        {vehicleType.kind}
                    </Text>
                    <Text variant="SmallText" color="textSecondary" ellipsis>
                        {i18n.VehicleType.id}: {vehicleType.externalId}
                    </Text>
                </Grid>
                <Grid item xs={3}>
                    <Text variant="SmallText">{`${i18n.VehicleType.consumption} (${i18n.VehicleType.perKm})`}</Text>
                    <Text variant="SmallText">{`${i18n.VehicleType.consumption} (${i18n.VehicleType.perHour})`}</Text>
                    <Text variant="SmallText">{i18n.VehicleType.co2Emission}</Text>
                </Grid>

                {fuelList.map(fuel => {
                    const settings = getFuelSetting(vehicleType, fuel) || {
                        fuel,
                        consumption: 0,
                        consumptionPerHour: 0,
                        co2Emission: 0,
                    };

                    return (
                        <Grid item xs={2} key={fuel} alignItems="flex-end">
                            <Text variant="SmallText">{settings.consumption}</Text>
                            <Text variant="SmallText">{settings.consumptionPerHour}</Text>
                            <Text variant="SmallText">{settings.co2Emission}</Text>
                        </Grid>
                    );
                })}
            </Grid>
        </CardListItem>
    );
});
